import { actionColumn } from "@/components/Table/table.interface";
import { MODULES } from "@/constants";
const ListColumns = [
  { id: "name", label: "Name", width: 300, wrap: true, grow: true },
  { id: "title", label: "Title", width: 300, wrap: true },
  { id: "sponsored", label: "Sponsored name", width: 240, wrap: true },
  actionColumn({
    module: MODULES.NATIVE_OFFERS,
    actions: ["update", "delete"],
  }),
];

const CREATIVE_NATIVE_TEMPLATE_TYPES = {
  IMAGE_CONTENT: "IMAGE_CONTENT",
};

const SPONSORED_ASSET_SIZE = {
  [CREATIVE_NATIVE_TEMPLATE_TYPES.IMAGE_CONTENT]: ["128x128"],
};
export { ListColumns, SPONSORED_ASSET_SIZE, CREATIVE_NATIVE_TEMPLATE_TYPES };
